const LOGOS = {
  bridgeInteractive: {
    src: '/logos/bridge-interactive.svg',
    label: 'Bridge Interactive',
    short: 'Bridge',
  },
  trestle: {
    src: '/logos/trestle.svg',
    label: 'Trestle',
    short: 'Trestle',
  },
  mlsGrid: {
    src: '/logos/mls-grid.svg',
    label: 'MLS Grid',
    short: 'MLS Grid',
  },
  rmls: {
    src: '/logos/mls-grid.svg',
    label: 'RMLS',
    short: 'RMLS',
  },
}

export function platformKey(source) {
  if (!source) return null
  const platform = source.platformAdapterName || source.platform || source.name
  if (!platform) return null
  const key = String(platform)
  if (LOGOS[key]) return key
  const lower = key.toLowerCase()
  if (lower.includes('bridge')) return 'bridgeInteractive'
  if (lower.includes('trestle')) return 'trestle'
  if (lower.includes('grid') || lower.includes('mlsgrid')) return 'mlsGrid'
  if (lower.includes('rmls')) return 'rmls'
  return null
}

export function sourceLogo(source) {
  const key = platformKey(source)
  return key ? LOGOS[key] : null
}

export function sourceDisplayName(source) {
  const logo = sourceLogo(source)
  if (logo) return logo.label
  return (source && source.name) || 'Source'
}

export default LOGOS
